<div class="stage" (window:resize)="onResize()" [@stageTransition]="getState(scene)" #stage>
	<div class="stage__background"></div>
	<div class="stage__switch">
		<div *ngIf="scene.switch" class="background" [ngStyle]="scene.style"></div>
	</div>
	<div class="stage__fade">
		<div *ngIf="scene.background" class="background" [ngStyle]="scene.style"></div>
	</div>
	<div class="stage__scene">
		<div *ngFor="let hotspot of scene.hotspots" class="hotspot hotspot--{{ hotspot.type }}" [ngClass]="{'hotspot--active': (hotspot.active || isHotspotActive(hotspot.id))}" [ngStyle]="hotspot.style">
			<div class="hotspot__circle-container hotspot--{{ hotspot.type }}__circle-container" (tap)="onClickHotspot(hotspot)">
				<div class="hotspot__inner-circle hotspot--{{ hotspot.type }}__inner-circle fa {{ hotspot.icon }}" [ngClass]="{'hotspot--active__inner-circle': (hotspot.active || isHotspotActive(hotspot.id))}"></div>
				<div class="hotspot__outer-circle hotspot--{{ hotspot.type }}__outer-circle" [ngClass]="[(hotspot.active ? 'hotspot--' + hotspot.type + '__outer-circle--active' : '')]"></div>
			</div>
			<div class="hotspot__label hotspot__label--{{ hotspot.type }}" [ngClass]="{'hotspot--active__label': (hotspot.active || isHotspotActive(hotspot.id))}" (tap)="onClickHotspot(hotspot)">{{ hotspot.label[language] }}</div>
		</div>
	</div>
	<div *ngIf="scene.link" class="stage__back btn-scene-back" (tap)="onClickBack(scene.link)">
		<i class="fa fa-reply"></i>
	</div>
	<div *ngIf="scene.text" class="infobox" [@toggleInfobox]="infoboxIsOpen">
		<div class="infobox__title">
			<i class="infobox__toggle fa" (click)="onToggleInfobox()" [ngClass]="{'infobox__toggle--opened': infoboxIsOpen}"></i>
			<div *ngIf="scene.path.length === 1" class="infobox__path">
				<h2 class="infobox__headline">{{ scene.path[0][language] }}</h2>
			</div>
			<div *ngIf="scene.path.length === 2" class="infobox__path">
				<h3 class="infobox__headline infobox__headline--small">{{ scene.path[0][language] }}</h3>
				<h2 class="infobox__headline">{{ scene.path[1][language] }}</h2>
			</div>
			<div class="infobox__background" [@fadeBackground]="infoboxIsOpen"></div>
		</div>
		<div class="infobox__background" [@fadeBackground]="infoboxIsOpen"></div>
		<p class="infobox__text">{{ scene.text[language] }}</p>
	</div>
</div>


// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/components/stage/stage.component.html